import { Badge, Loader } from '@mantine/core';
import React from 'react';
import { BackgroundProcess } from 'src/data-capture/hooks/file-uploads/types';

type Props = {
  status: BackgroundProcess['status'] | 'UNFILED';
};

const StatusMap = {
  PENDING: {
    variant: 'processing',
    text: 'Extracting...',
    showLoader: true,
  },
  PROCESSING: {
    variant: 'processing',
    text: 'Extracting...',
    showLoader: true,
  },
  SUCCESS: {
    variant: 'success',
    text: 'Ready',
    showLoader: false,
  },
  FAILED: {
    variant: 'error',
    text: 'Failed',
    showLoader: false,
  },
  UNFILED: {
    variant: 'gray',
    text: 'Active',
    showLoader: false,
  },
};

export default function FileStatusPill({ status }: Props) {
  const { variant, text, showLoader } = StatusMap[status];

  return (
    <Badge
      variant={variant}
      style={{
        borderRadius: 100,
        textTransform: 'none',
        fontWeight: 500,
      }}
      size={'lg'}
      px={'xxs'}
      leftSection={showLoader && <Loader size={8} color={'gray.8'} />}
    >
      {text}
    </Badge>
  );
}
